export * from './post-standort.component';
export * from './post-standort.component.module';